import HeadingIcon from "../../images/defualt_heading_new_icon.svg";
import SubHeadingIcon from "../../images/defualt_sub-heading_new_icon.svg";
import BodyIcon from "../../images/defualt_body_new_icon.svg";
export const customTextBlock = (editor) => {
    editor.Blocks.add("h1", {
        category: "extra",
        label: "Heading",

        media: `<img src="${HeadingIcon}" class="heading-block" title="Heading" draggable="true" />`,

        content: `<h1 data-gjs-type="text"  id="h1class">Heading</h1>  <style>
            #h1class {
                margin-block-start: 0;
                margin-block-end: 0;
                font-size: 40px;
                    font-weight: 700;
                    display: block;                    
            }
        </style>`,

    });

    editor.Blocks.add("h2", {
        category: "extra",
        label: "Sub Heading",

        media: `<img src="${SubHeadingIcon}" class="sub-heading-block" title="Sub Heading" draggable="true" />`,

        content: `<h2 data-gjs-type="text"  id="h2class">Sub Heading</h2>
          <style>
          #h2class {
              margin-block-start: 0;
              margin-block-end: 0;
              font-size: 32px;
                    font-weight: 500;
                    display: block;     
          }
      </style>`,

    });
    editor.Blocks.add("para", {
        category: "extra",
        label: "Paragraph",

        media: `<img src="${BodyIcon}" class="paragraph-block" title="Paragraph" draggable="true"/>`,

        content: `<p data-gjs-type="text"  id="paraClass">Insert your paragraph here</p>  <style>
             #paraClass {
                 margin-block-start: 0;
                 margin-block-end: 0;
                 font-size: 24px;
                    font-weight: 400;
                    display: block;
             }
         </style>`,



    });
}